<template>
    <div class="table-container">
        <div class="vendors-subheader ods-mb-9">
            <ods-input-search
              class="ods-mt-3"
              size='hecto'
              outlined
              placeholder='Buscar'
              @input='userSearch'>
            </ods-input-search>
            <ventana-usuario :codcomercio="codcomercio" :profiles="this.profiles"></ventana-usuario>
        </div>
        <div>
          <div v-if="usu">
            <ods-table
            :data="newListadoUsuarios"
            style="width: 100%"
            highlight-current-row
            reserve-selection>
                <ods-table-column
                prop="desperfil"
                label="perfil"
                min-width="120"
                sortable>
                </ods-table-column>
                <ods-table-column
                prop="nomcompleto"
                label="nombre y apellido"
                min-width="150"
                sortable>
                </ods-table-column>
                <ods-table-column
                prop="usuario"
                label="alias"
                min-width="100"
                sortable>
                </ods-table-column>
                <ods-table-column
                prop="email"
                label="correo electronico"
                align="center"
                min-width="120"
                header-align="center"
                sortable>
                </ods-table-column>
                <ods-table-column
                prop="object"
                label="ACCIONES"
                align="right"
                min-width="35">
                  <template slot-scope="scope">
                    <ods-row>
                        <ventana-borrar-usuario
                        :codcomercio="codcomercio"
                        :isVisible="dialogVisible"
                        :rowDelete="rowSeleccionada"
                        :toggleVisible="toggleDeleteUser"
                        @closingDialog="dialogVisible = $event">
                        </ventana-borrar-usuario>
                      <ventana-modificar-usuario
                        :codcomercio="codcomercio"
                        :filtradoComercio="true"
                        :isVisible="dialogModificarVisible"
                        :rowModify="rowSeleccionada"
                        :toggleVisible="toggleModifyUser"
                        @closingDialog="dialogModificarVisible = $event">
                        </ventana-modificar-usuario>
                      <ods-actions-menu
                        customClass="card-menu"
                        icon="overflow-menu"
                        color="#888A91"
                        size="18"
                        popoverPosition="bottom-end">
                          <ul class="menu">
                            <li class="menu__item">
                              <a href="#" @click.prevent="openModifyModal(scope.$index, scope.row)">
                                <ods-icon name="eye" color="#B6B6B6" size="24" style="vertical-align: middle" class="ods-mr-2"></ods-icon>
                                <span>Ver detalle</span>
                              </a>
                            </li>
                            <li class="menu__item">
                              <a href="#" @click.prevent="openDeleteModal(scope.$index, scope.row)" style="color: #DE2F2F">
                                <ods-icon name="delete" color="#DE2F2F" size="24" style="vertical-align: middle" class="ods-mr-2"></ods-icon>
                                <span>Eliminar usuario</span>
                              </a>
                            </li>
                          </ul>
                      </ods-actions-menu>
                    </ods-row>
                  </template>
                </ods-table-column>
            </ods-table>
          </div>
          <div v-else style="text-align: center; margin-top: 30px;">
            <ods-row>
              <img :src="require('@/assets/icons/pic_map.svg')">
            </ods-row>
            <ods-row>
              <span class="todas-las-rutas-de-e">Sin resultados de búsqueda</span>
            </ods-row>
          </div>
        </div>
      <ods-pagination
      layout="prev, pager, next"
      style="text-align:
      right; padding: 20px;"
      @current-change="handleCurrentChange"
      :page-size="20"
      :total='this.totalpaginas'></ods-pagination>
         <dialog-generic-error
      :message="errorMessage"
      :dialogError="dialogError"
      :before-close-fn="handleCloseSession"
      @dialogClosed="closeDialogError($event)">
      </dialog-generic-error>
  </div>
</template>

<script>
import VentanaUsuario from '@/components/dialogs/VentanaUsuario'
import VentanaBorrarUsuario from '@/components/dialogs/VentanaBorrarUsuario'
import VentanaModificarUsuario from '@/components/dialogs/VentanaModificarUsuario'
import DialogGenericError from '@/components/dialogs/DialogGenericError'
import { mapGetters } from 'vuex'
export default {
  props: ['usu', 'codcomercio', 'data', 'profiles'],
  data () {
    return {
      value: '',
      boolean: false,
      totalpaginas: 0,
      searched: '',
      mostrarUsu: true,
      descomercio: '',
      dialogVisible: false,
      dialogModificarVisible: false,
      rowSeleccionada: '',
      isVisible: false,
      dialogError: false,
      hasErrors: false,
      errorMessage: '',
      imagen: false,
      mostrarTabla: true,
      listadoUsuarios: [],
      newListadoUsuarios: [],
      icon: 'overflow-menu',
      popoverPosition: 'left-end',
      mobilePopoverPosition: 'bottom-end',
      boundariesElement: '#root',
      myClass: 'myClass',
      actionMenuRow: false
    }
  },
  methods: {
    userSearch (text) {
      this.newListadoUsuarios = this.listadoUsuarios.filter((res) => {
        return res.desperfil.toLowerCase().includes(text.toLowerCase()) ||
          res.nombre.toLowerCase().includes(text.toLowerCase()) ||
          res.apelli1.toLowerCase().includes(text.toLowerCase()) ||
          res.apelli2.toLowerCase().includes(text.toLowerCase()) ||
          res.usuario.toLowerCase().includes(text.toLowerCase())
      })
    },
    handleCurrentChange (val) {
      this.getPlantListPagination(val)
    },
    openDeleteModal (index, row) {
      this.rowSeleccionada = row
      this.toggleDeleteUser()
    },
    openModifyModal (index, row) {
      this.rowSeleccionada = row
      this.toggleModifyUser()
    },
    openModifyModalRow (index, row) {
      if (this.actionMenuRow === false) {
        this.rowSeleccionada = index
        this.toggleModifyUser()
        this.actionMenuRow = false
      }
      this.actionMenuRow = false
    },
    toggleDeleteUser () {
      if (this.dialogVisible) {
        this.dialogVisible = false
      } else {
        this.dialogVisible = true
      }
    },
    toggleModifyUser () {
      if (this.dialogModificarVisible) {
        this.dialogModificarVisible = false
      } else {
        this.dialogModificarVisible = true
      }
    },
    onShow () {
      this.actionMenuRow = true
    },
    handleCloseSession () {
      this.$store.dispatch('logout')
    },
    closeDialogError (e) {
      this.dialogError = e
      this.handleCloseSession()
    },
    displayErrorDialog (msg) {
      this.errorMessage = `${msg}`
      this.dialogError = true
    },
    ...mapGetters([
      'getlistUsersData'
    ])
  },
  watch: {
    data (newData, oldData) {
      this.newListadoUsuarios = newData
      this.listadoUsuarios = newData
    }
  },
  components: {
    'ventana-usuario': VentanaUsuario,
    'ventana-borrar-usuario': VentanaBorrarUsuario,
    'ventana-modificar-usuario': VentanaModificarUsuario,
    DialogGenericError
  }
}
</script>

<style lang="scss" scoped>
  .expanded {
    right: 10%;
  }
  .notExpanded {
    right: 2%;
  }
  .table-container {
    background-color: $--color-white;
  }

  .table-content {
    padding: rem(10);
  }
  .todas-las-rutas-de-e {
    height: 24px;
    color: #6E767D;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
    text-align: center;
  }
  .pointer {
    cursor: pointer;
  }
  .bg-01-components-popover-bg {
    height: 100px;
    width: 144px;
    background-color: #FFFFFF;
    box-shadow: 0 2px 10px 0 rgba(0,0,0,0.1);
  }
  /deep/ .ods-table td {
    padding: 9px 0;
  }
  .myClass{
    width: 144px;
    height: 648px;
    border-radius: 0;
    padding: 0;
  }
  /deep/.ods-actions-menu {
    width: 144px;
    border-radius: 0;
    padding: 0px;
  }
  /deep/ .ods-icon-delete {
    color: red;
  }
  .vendors-subheader {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
</style>
